/**
 * Canonical 6-player MVP rotation: 12 games, each player plays 8 and sits out 4.
 * The app starts at a random game and loops, so all of this holds from any starting game:
 * - nobody sits out two games in a row, and everyone has exactly one run of 3 games on court
 *   (the rest are runs of 1–2)
 * - every pair partners once or twice (all 15 pairs), never the same partners two games running
 * - every pair faces each other 3 or 4 times, and no matchup is played twice
 * - everyone serves exactly twice, 6 games apart (the server is teamA[0])
 *
 * Generated by scripts/six-player-rotation-search.mjs.
 */

export const SIX_PLAYER_MVP_GAMES = [
  { teamA: [2, 3], teamB: [4, 5], sitsOut: [0, 1] },
  { teamA: [0, 4], teamB: [1, 5], sitsOut: [2, 3] },
  { teamA: [1, 0], teamB: [2, 3], sitsOut: [4, 5] },
  { teamA: [3, 5], teamB: [2, 4], sitsOut: [0, 1] },
  { teamA: [4, 1], teamB: [0, 2], sitsOut: [3, 5] },
  { teamA: [5, 3], teamB: [0, 4], sitsOut: [1, 2] },
  { teamA: [2, 5], teamB: [1, 3], sitsOut: [0, 4] },
  { teamA: [0, 3], teamB: [1, 4], sitsOut: [2, 5] },
  { teamA: [1, 2], teamB: [4, 5], sitsOut: [0, 3] },
  { teamA: [3, 0], teamB: [2, 5], sitsOut: [1, 4] },
  { teamA: [4, 3], teamB: [0, 1], sitsOut: [2, 5] },
  { teamA: [5, 0], teamB: [1, 2], sitsOut: [3, 4] },
];

/** Maps to team1/team2 in LiveSession; server is resolved from indices after shuffle */
export const SIX_PLAYER_MVP_SERVING = SIX_PLAYER_MVP_GAMES.map(() => ({ servingTeam: 'team1', servingPlayerIndex: 0 }));
